import React from 'react';
import {observer} from 'mobx-react';
import {Table, Checkbox} from 'components';
import {Modal, ModalButtons} from 'components/modals';
import DueDateView from './DueDateView';
import Assignee from './Assignee';

const TaskTemplateName = observer(({model}) => {
  return <Checkbox checked={model.checked} onChange={e => model.checked = e.checked}/>;
});

const COLUMNS = [
  {
    header: '',
    component: TaskTemplateName,
    width: 1
  },
  {
    header: 'tasks.Task Name',
    attribute: 'taskTemplate.name',
    width: 4
  },
  {
    header: 'tasks.Assignee',
    component: Assignee,
    width: 4
  },
  {
    header: 'tasks.Due',
    component: DueDateView,
    width: 3
  }
];

const LOCALIZATION = {
  addModel: 'tasks.Create new task',
  emptyState: 'company_settings.tasks.No tasks to display'
};

const AddTaskTemplatesModal = observer(({uiState}) => {
  const {filteredTaskTemplates} = uiState;

  return (
    <Modal
      isOpen={uiState.addTaskTemplateModalOpen}
      onHide={() => uiState.closeAddTaskTemplateModal()}
      title={`tasks.${uiState.config.selectTemplatesToUse}`}>
      <Table
        showLinks={false}
        indexBy='taskTemplate.clientId'
        models={filteredTaskTemplates}
        columns={COLUMNS}
        localization={LOCALIZATION}
        onAdd={() => uiState.openCreateTaskTemplateModal()} />
      <ModalButtons
        onSave={() => uiState.saveSelectedTaskTemplates()}
        onCancel={() => uiState.closeAddTaskTemplateModal()}/>
    </Modal>
  );
});

export default AddTaskTemplatesModal;
